module.exports = "<div class=\"app-root\" [class.fullLayout]=\"!index.isShowNav\" [class.miniNav]=\"index.miniNav\">\r\n    <app-head-top *ngIf=\"index.isShowNav\"></app-head-top>\r\n    <app-side-nav *ngIf=\"index.isShowNav\"></app-side-nav>\r\n    <div class=\"main-container\" [class.noNav]=\"!index.isShowNav\">\r\n        <router-outlet></router-outlet>\r\n        <app-loading [isLoading]=\"loading | async\"></app-loading>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/system/index/index.component.html
// module id = ../../../../../src/app/home/components/system/index/index.component.html
// module chunks = main